export const withNullsRemoved = <T extends object>(
  object: T,
): { [K in keyof T]: NonNullable<T[K]> | undefined } => {
  const entries = Object.entries(object);

  return Object.fromEntries(
    entries.filter(([_, value]: [string, unknown]): boolean => value !== null),
  ) as {
    [K in keyof T]: NonNullable<T[K]> | undefined;
  };
};
